<template>
  <i class="svg-icon" :style="getInlineStyling"></i>
</template>

<script>
export default {
  /**
   * A Vue.js komponens, amely dinamikusan alkalmazza az SVG-t mint maszk képet a `src` prop alapján.
   * A `getInlineStyling` computed property hozza létre a megfelelő inline stílust a maszkoláshoz.
   */
  props: {
    src: {
      required: true,
      type: String,
    },
  },

  computed: {
    getInlineStyling() {
      return [
        "display:inline-block",
        "flex-shrink:0",
        "width:16px",
        "height:16px",
        "background:currentColor",
        "mask-image:url(" + this.src + ")",
        "-webkit-mask-image:url(" + this.src + ")",
        "mask-size:contain",
        "-webkit-mask-size:contain",
        "mask-repeat:no-repeat",
        "-webkit-mask-repeat:no-repeat",
        "mask-position:center",
        "-webkit-mask-position:center",
      ].join(";");
    },
  },
};
</script>
